export const quizHost: Record<string, string> = {
  'qhost.hostOnly': 'Trang này dành cho Quiz Host. Liên hệ admin để được cấp quyền.',
  'qhost.checkingAccess': 'Đang kiểm tra quyền truy cập...',
  'qhost.resumeTitle': 'Tiếp tục ván trước?',
  'qhost.resumeCode': 'Mã ván đã lưu:',
  'qhost.resume': 'Tiếp tục ván này',
  'qhost.resumeNew': 'Tạo ván mới',
  'qhost.resuming': 'Đang kết nối lại...',
  'qhost.setupTitle': 'Mở ván Quiz mới',
  'qhost.selectQuiz': 'Chọn quiz',
  'qhost.selectQuizPlaceholder': '-- Chọn quiz --',
  'qhost.noQuizzes': 'Chưa có quiz nào. Tạo quiz ở trang Quản lý Quiz trước.',
  'qhost.hostName': 'Tên host',
  'qhost.hostNamePlaceholder': 'VD: MC',
  'qhost.settingsTitle': 'Cài đặt (tuỳ chọn)',
  'qhost.timeLimit': 'Thời gian mỗi câu (giây, 0 = mặc định của câu hỏi)',
  'qhost.mode': 'Chế độ chuyển câu',
  'qhost.modeManual': 'Thủ công (host bấm Câu tiếp)',
  'qhost.modeAuto': 'Tự động',
  'qhost.createGame': 'Tạo ván',
  'qhost.creating': 'Đang tạo...',
  'qhost.gameCode': 'Mã ván',
  'qhost.lobbyCodeHint': 'Người chơi nhập mã này để tham gia',
  'qhost.players': 'Người chơi',
  'qhost.noPlayers': 'Đang chờ người chơi tham gia...',
  'qhost.kick': 'Đuổi',
  'qhost.kickConfirmTitle': 'Đuổi người chơi',
  'qhost.kickConfirmMessage': 'Đuổi người chơi này khỏi ván?',
  'qhost.startGame': 'Bắt đầu ván',
  'qhost.endGame': 'Kết thúc ván',
  'qhost.endGameConfirmTitle': 'Kết thúc ván',
  'qhost.endGameConfirmMessage': 'Kết thúc ván và đuổi tất cả người chơi? Không thể hoàn tác.',
  'qhost.question': 'Câu hỏi',
  'qhost.slide': 'Slide',
  'qhost.answeredCount': 'đã trả lời',
  'qhost.reveal': 'Hiện đáp án',
  // Câu gõ chữ — ô đáp án chuẩn trên màn host và trong lịch sử.
  'qhost.textAnswerKey': 'Đáp án chuẩn',
  'qhost.showLeaderboard': 'Bảng xếp hạng',
  'qhost.next': 'Câu tiếp',
  'qhost.nextSlide': 'Tiếp tục',
  'qhost.correctAnswerLabel': 'Đáp án đúng',
  'qhost.revealTitle': 'Kết quả câu này',
  'qhost.correctCount': 'đúng',
  'qhost.wrongCount': 'sai',
  'qhost.topScorers': 'Điểm cao nhất vòng này',
  'qhost.leaderboardTitle': 'Bảng xếp hạng',
  'qhost.finishedTitle': 'Ván chơi kết thúc!',
  'qhost.fullResults': 'Kết quả đầy đủ',
  'qhost.newGame': 'Mở ván mới',
  'qhost.reconnected': 'Đã kết nối lại. Ván đang chạy — dùng nút bên dưới để tiếp tục điều khiển.',
  'qhost.gameEnded': 'Ván đã kết thúc.',
  'qhost.multiplier': 'Hệ số điểm',
  'qhost.rank': 'Hạng',
  'qhost.score': 'điểm',

  // Team mode
  'qhost.gameMode': 'Chế độ chơi',
  'qhost.gameModeIndividual': 'Cá nhân',
  'qhost.gameModeTeam': 'Theo đội',
  'qhost.teamCount': 'Số đội',
  'qhost.teamAssignment': 'Cách chia đội',
  'qhost.teamAssignmentAuto': 'Tự động cân bằng khi join',
  'qhost.teamAssignmentRandom': 'Ngẫu nhiên khi bắt đầu',
  'qhost.teamAssignmentCaptain': 'Đội trưởng chọn',
  'qhost.teamScoring': 'Cách tính điểm đội',
  'qhost.teamScoringSum': 'Tổng điểm',
  'qhost.teamScoringAverage': 'Điểm trung bình',
  'qhost.teams': 'Các đội',
  'qhost.shuffleTeams': '🔀 Xáo trộn đội',
  'qhost.unassignedPool': 'Chưa xếp đội',
  'qhost.unassignedEmpty': 'Mọi người đã có đội',
  'qhost.assignCaptain': 'Gán làm đội trưởng',
  'qhost.captainPicking': 'Đội trưởng đang chọn thành viên',
  'qhost.teamRankings': 'Thứ hạng đội',
  'qhost.topPlayers': 'Người chơi xuất sắc',

  // Game history
  'qhost.historyTitle': 'Lịch sử ván chơi',
  'qhost.historyEmpty': 'Chưa có ván chơi nào.',
  'qhost.colCode': 'Mã ván',
  'qhost.colQuizTitle': 'Quiz',
  'qhost.colStatus': 'Trạng thái',
  'qhost.colGameMode': 'Chế độ',
  'qhost.colPlayerCount': 'Số người chơi',
  'qhost.colAvgRating': 'Đánh giá TB',
  'qhost.colCreatedAt': 'Bắt đầu',
  'qhost.colFinishedAt': 'Kết thúc',
  'qhost.statusWaiting': 'Đang chờ',
  'qhost.statusPlaying': 'Đang chơi',
  'qhost.statusFinished': 'Đã xong',
  'qhost.statusEnded': 'Đã kết thúc',
  'qhost.detailTitle': 'Chi tiết ván',
  'qhost.detailPlayers': 'Người chơi',
  'qhost.detailQuestions': 'Câu hỏi & tỉ lệ đúng',
  'qhost.qrHint': 'Quét để vào ván',
  'qhost.soundOn': 'Đang bật âm thanh',
  'qhost.soundOff': 'Đang tắt âm thanh',
  'qhost.fastestCorrect': 'Nhanh nhất',
  'qhost.questionStatsHint': 'bấm vào câu hỏi để xem phân bố đáp án',
  'qhost.duration': 'Thời lượng',
  'qhost.minutes': 'phút',
  'qhost.colAvgTime': 'TG TB',
  'qhost.statQuizzes': 'Quiz',
  'qhost.statGames': 'Ván đã chơi',
  'qhost.statPlayers': 'Lượt chơi',
  'qhost.deleteGameConfirmTitle': 'Xoá ván chơi',
  'qhost.deleteGameConfirmMessage': 'Xoá vĩnh viễn ván này cùng toàn bộ kết quả và feedback?',
  'qhost.playerAnswersHint': 'bấm vào người chơi để xem lịch sử trả lời',
  'qhost.noAnswers': 'Không có dữ liệu câu trả lời',
  'qhost.skipped': 'Bỏ qua',
  'qhost.colNickname': 'Tên',
  'qhost.colScore': 'Điểm',
  'qhost.colCorrect': 'Số câu đúng',
  'qhost.colMaxStreak': 'Streak cao nhất',
  'qhost.detailTeams': 'Kết quả đội',
  'qhost.detailFeedback': 'Phản hồi',
  'qhost.noFeedback': 'Chưa có phản hồi.',
  'qhost.backToList': '← Danh sách',
  'qhost.employeeMode': 'Quiz Supernova Connect (tính S-point)',
  'qhost.employeeModeHint': 'Người chơi gắn với mã nhân viên, mỗi người chơi 1 lần, host không chơi.',
  // Số điểm lấy từ Quản trị → Cấu hình → Mùa giải (xem quiz-host-payout-points.ts); "5" là QUIZ_RANK_MIN_PLAYERS của API.
  'qhost.employeeModePoints': 'Chơi +{join} S-point; hạng 1/2/3 +{r1}/+{r2}/+{r3} khi có từ 5 người.',
  'qhost.employeeModePointsTeam': 'Chơi +{join} S-point; mỗi người trong đội hạng 1/2/3 +{r1}/+{r2}/+{r3} khi có từ 5 người.',
  'qhost.teamAssignmentTeamBuilding': 'Theo Team Building',
  'qhost.teamBuildingEvent': 'Đợt Team Building',
  'qhost.teamBuildingPlaceholder': '-- Chọn đợt --',
  'qhost.teamBuildingOption': '{name} — {teams} đội, {members} người',
  'qhost.teamBuildingNotFinal': 'chưa chốt team',
  'qhost.teamBuildingHint': 'Mỗi người tự vào đúng đội đã chia ở đợt này; người ngoài danh sách không vào chơi được. Chỉ chọn được đợt đã Chốt team.',
};
